export class InstitutionProgram {
    public category: string;
    public createdAt: string;
    public id: string;
    public institutionId: string;
    public origin: Origin;
    public proglatProgramId: string;
    public status: string;
    public updatedAt: string;
}

export class Origin {
    public averageRating: number;
    public category: string;
    public certificationLinked: boolean;
    public code: string;
    public coverImage: string;
    public createdAt: string;
    public description: string;
    public editorId: string;
    public id: string;
    public instructorEducationId: string;
    public instructorHealth: string;
    public instructorMethodologicalCompetence: string;
    public instructorQualification: string;
    public instructorTechnicalCompetence: string;
    public instructorWorkExperience: string;
    public kbjiPositionGroupId: string;
    public lemsarInstitutionId: string;
    public level: string;
    public materials: string;
    public parentId: string;
    public private: boolean;
    public publisherId: string;
    public status: string;
    public subVocationalId: string;
    public summaryRating: any[];
    public title: string;
    public tkmType: string;
    public tools: string;
    public traineeBasicSkill: string;
    public traineeEducationId: string;
    public traineeGender: string;
    public traineeHealth: string;
    public traineeMaxAge: string;
    public traineeMinAge: string;
    public traineeQualification: string;
    public traineeTrainingExperience: string;
    public traineeWorkExperience: string;
    public type: string;
    public updatedAt: string;
    public version: string;
    public vocationalId: string;
    public vocational: any;
    public subVocational: any;
    public selected: boolean;
    public totalTopic: string;
    public totalDuration: string;
}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/model/institution-program.ts